export * from '@core/js/store/constants';

export const PRAGMATIC_PLAY_REDUCER = 'pragmaticPlay'; // @theme
